module.exports = __webpack_public_path__ + "img/slider_12.bf389f95.jpg";